import React, { useState, useEffect } from "react";
import moment from "moment";

const ShowRouteInfo = ({
  field: { name },
  form: { setFieldValue },
  routeAddressState,
  ...props
}) => {
  useEffect(() => {
    console.log("++++++++++++++++===================))))))))))))))))))))))(((((((((((")
    console.log(routeAddressState)
    console.log(props)
    if (routeAddressState.budgetedRouteTat) { document.getElementById('route-tat').value = routeAddressState.budgetedRouteTat; setFieldValue("budgeted_time", routeAddressState.budgetedRouteTat) }
    if (routeAddressState.budgetedRouteKm) { document.getElementById('route-km').value = routeAddressState.budgetedRouteKm; setFieldValue("budgeted_kms", routeAddressState.budgetedRouteKm) }
  }, [routeAddressState]);

  const setInputChange = (e, onChangeTo) => {
    let value = e.target.value;
    if (onChangeTo == 'budgeted_kms') {
      setFieldValue(onChangeTo, value)
    } else {
      setFieldValue(onChangeTo, value)
      
      let addDate = moment.tz(moment(props.requested_pickup_date_booking).add(parseInt(value), 'hours').format('YYYY-MM-DD HH:mm'), 'Asia/Kolkata');

      setFieldValue(props.bookingDeliveryDateName, addDate)
    }
  }

  return (
    <>
      {routeAddressState != "null" &&
        routeAddressState != "undefined" &&
        (routeAddressState.origin || routeAddressState.routeCheckPointNames) ? (
        <div className="display-flex-center flex-wrap">
          <div>
            <span className="address-label">Origin</span>
            <span className="address-inputfields">
              {" "}
              :{" "}
              {routeAddressState.origin ||
                routeAddressState.routeCheckPointNames?.split(",")[0]}
            </span>
          </div>
          <div className="address-divider">|</div>
          <div>
            <span className="address-label">Destination</span>
            <span className="address-inputfields">
              {" "}
              :{" "}
              {routeAddressState.destination ||
                routeAddressState.routeCheckPointNames?.split(",")[routeAddressState?.routeCheckPointNames?.split(",").length - 1]}
            </span>
          </div>
          <div className="address-divider">|</div>
          <div className="display-flex-center flex-wrap">
            <div className="display-flex-center">
              <span className="address-label">Budgeted Distance</span>
              <div className="address-inputfields display-flex-center">
                {" "}
                :
                <input
                  className="route-input-variable display-flex-center placeholder-dark remove-incrementer"
                  disabled={props.mode == 'view' ? true : false}
                  type="number"
                  name="budgeted_kms"
                  placeholder={
                    routeAddressState.budgeted_kms ||
                    routeAddressState.budgetedRouteKm
                  }
                  id="route-km"
                  onChange={(e) => setInputChange(e, "budgeted_kms")}
                />{" "}
                &nbsp;K.M
              </div>
            </div>
            <div className="address-divider">|</div>
            <div className="display-flex-center">
              <span className="address-label">Budgeted Time</span>
              <div className="address-inputfields display-flex-center">
                {" "}
                :
                <input
                  className="route-input-variable display-flex-center placeholder-dark remove-incrementer"
                  disabled={props.mode == 'view' ? true : false}
                  type="number"
                  id="route-tat"
                  placeholder={
                    routeAddressState.budgeted_time ||
                    routeAddressState.budgetedRouteTat
                  }
                  name="budgeted_time"
                  onChange={(e) => setInputChange(e, "budgeted_time")}
                />{" "}
                &nbsp;Hrs
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ShowRouteInfo;
